import { createApp } from "vue";
import { createI18n } from "vue-i18n";
import { createPinia } from "pinia";
import { router } from "./router";
import ToastContainer from "./core/components/base/Toast.vue";
import "./assets/styles/style.css";
import "@fortawesome/fontawesome-free/css/all.css";
import licensePlateMask from "./directives/mask";
import "@/core/components/charts/echarts";
import VChart from "vue-echarts";
import { defineRule, configure } from "vee-validate";
import { required, email, min, max, numeric } from "@vee-validate/rules";
import { localize } from "@vee-validate/i18n";
// importa ficheiros JSON
import pt from "./locales/pt.json";
import en from "./locales/en.json";
import { initKeycloak } from "./modules/auth/services/authService";

import App from "./App.vue";

if (window.top && window.top !== window.self) {
  window.top.location.href = window.self.location.href;
}

defineRule("required", required);
defineRule("email", email);
defineRule("min", min);
defineRule("max", max);
defineRule("numeric", numeric);

configure({
  generateMessage: localize("pt", {
    messages: {
      required: "Campo obrigatório",
      email: "Email inválido",
      min: "Mínimo de {length} caracteres",
    },
  }),
});

await initKeycloak();

const pinia = createPinia();
const app = createApp(App);

// cria instância do i18n
const i18n = createI18n({
  legacy: false, // Composition API mode
  locale: "pt", // idioma inicial
  fallbackLocale: "en", // fallback
  messages: {
    pt,
    en,
  },
});

app.component("ToastContainer", ToastContainer);
app.directive("license-plate-mask", licensePlateMask);
app.use(pinia);
app.use(router);
app.use(i18n); // regista o i18n
app.component("VChart", VChart);
app.mount("#app");
